import "./Spinner.css";

//Inspired by https://youtu.be/BxpjA9t4dJE?t=629
export const Spinner = () => {
  return (
    <div className='spinner-wrapper'>
      <div className='spinner' />
    </div>
  );
};
